import cloneDeep from 'lodash/cloneDeep';

export default function getInfoEcheancierPaiement(echeancierPaiement) {
  const newEcheancierPaiement = cloneDeep(echeancierPaiement);
  newEcheancierPaiement.forEach(echeance => {
    echeance.detail = [];
  });

  return newEcheancierPaiement;
}
